import SEO from '../components/SEO';
import './Legal.css';

const Privacy = () => {
  return (
    <>
      <SEO
        title="Privacy Policy"
        description="Read the Privacy Policy for IdeaPetal Games. Learn how we collect, use, and protect your personal information."
        keywords="privacy policy, data protection, user privacy"
      />
      <div className="legal-page">
        <div className="legal-header">
          <div className="container">
            <h1>Privacy Policy</h1>
            <p className="last-updated">Last Updated: {new Date().toLocaleDateString()}</p>
          </div>
        </div>

        <div className="legal-content">
          <div className="container">
            <section>
              <h2>1. Introduction</h2>
              <p>
                IdeaPetal Games ("we", "us", "our") is committed to protecting your privacy. This Privacy Policy 
                explains how we collect, use, disclose, and safeguard your information when you visit our website and 
                use our services.
              </p>
            </section>

            <section>
              <h2>2. Information We Collect</h2>
              <h3>2.1 Automatically Collected Information</h3>
              <p>We may collect certain information automatically when you visit our website, including:</p>
              <ul>
                <li>IP address</li>
                <li>Browser type and version</li>
                <li>Device information</li>
                <li>Pages visited and time spent on pages</li>
                <li>Referring website addresses</li>
              </ul>

              <h3>2.2 Information You Provide</h3>
              <p>
                We may collect information that you voluntarily provide to us, such as when you contact us through 
                our contact form or communicate with us via email.
              </p>
            </section>

            <section>
              <h2>3. How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul>
                <li>Provide, maintain, and improve our services</li>
                <li>Respond to your inquiries and provide customer support</li>
                <li>Analyze usage patterns and trends</li>
                <li>Ensure the security and integrity of our website</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section>
              <h2>4. Cookies and Tracking Technologies</h2>
              <p>
                We use cookies and similar tracking technologies to track activity on our website and hold certain 
                information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being 
                sent. However, if you do not accept cookies, you may not be able to use some portions of our website.
              </p>
              <p>
                For more detailed information about our use of cookies, please see our{' '}
                <a href="/cookie-policy">Cookie Policy</a>.
              </p>
            </section>

            <section>
              <h2>5. Third-Party Services</h2>
              <p>
                We may use third-party services, such as Google Analytics, to help us analyze how visitors use our 
                website. These services may collect information about your use of our website and other websites. 
                Please review the privacy policies of these third-party services for more information.
              </p>
              <p>
                We may also use advertising services, such as Google AdSense, after approval. These services may use
                cookies or similar technologies to measure ad performance, prevent fraud, and deliver relevant ads.
              </p>
            </section>

            <section>
              <h2>6. Data Security</h2>
              <p>
                We implement appropriate technical and organizational measures to protect your personal information 
                against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission 
                over the Internet or electronic storage is 100% secure.
              </p>
            </section>

            <section>
              <h2>7. Your Rights</h2>
              <p>Depending on your location, you may have certain rights regarding your personal information, including:</p>
              <ul>
                <li>The right to access your personal information</li>
                <li>The right to rectify inaccurate information</li>
                <li>The right to request deletion of your information</li>
                <li>The right to object to processing of your information</li>
                <li>The right to data portability</li>
              </ul>
            </section>

            <section>
              <h2>8. Children's Privacy</h2>
              <p>
                Our services are not directed to individuals under the age of 13. We do not knowingly collect personal 
                information from children under 13. If you are a parent or guardian and believe your child has provided 
                us with personal information, please contact us.
              </p>
            </section>

            <section>
              <h2>9. Changes to This Privacy Policy</h2>
              <p>
                We may update our Privacy Policy from time to time. We will notify you of any changes by posting the 
                new Privacy Policy on this page and updating the "Last Updated" date.
              </p>
            </section>

            <section>
              <h2>10. Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy, please contact us at{' '}
                <a href="/contact">our contact page</a>.
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default Privacy;
